import { useSearchParams } from "react-router-dom";
import { useGetTerminalBusinessAccount } from "../../../../../hooks/api/queries/useTerminals";
import { intergratedTerminalInfo } from "../../../../../localdata/intergratedTerminalInfo";

export const useAddIntegratedTerminals = () => {
  const [search] = useSearchParams();
  const terminalType = search.get("terminal_type");

  const { data: businessAccountDetails, isLoading: isFetchBusinessDetails } =
    useGetTerminalBusinessAccount({
      path: intergratedTerminalInfo?.[terminalType]?.getEndpoint,
      queryKey: intergratedTerminalInfo?.[terminalType]?.getQueryKey,
    });

  return {
    isLoading: isFetchBusinessDetails,
    businessAccountDetails,
    terminalType,
  };
};
